import {Injectable} from '@angular/core';
import {ApiService} from './services/api/api.service';

@Injectable({
    providedIn: 'root'
})
export class PdfreportService {

    constructor(private apiService: ApiService) {
    }

    public getQuotation(projectId?: number) {
        return this.apiService.getCall$(`pdf/report`, {projectId});
    }

    public getQuotationPdf(projectId?: number) {
        return this.apiService.getBlobCall(`pdf/reportpdf`, {projectId});
    }

    public getWorkareaPdf(workareaId?: number) {
        return this.apiService.getBlobCall(`pdf/workareapdf`, {workareaId});
    }
}
